export function mainMenu() {
    let mainMenu = document.querySelector('[data-mainMenu]');


    // Toggle menu
    let toggleBtn = mainMenu.querySelector('[data-mainMenuToggle]');
    let open = false;

    function toggleMenu() {
        if (open == false) {
            mainMenu.classList.add('_active');
            open = true;
            toggleBtn.setAttribute('aria-expanded', open);
        } else {
            mainMenu.classList.remove('_active');
            open = false;
            toggleBtn.setAttribute('aria-expanded', open);
        }
    }

    toggleBtn.addEventListener('click', evt => toggleMenu());




    // Tabs
    let tabBtns = document.querySelectorAll('[data-mainNavBtn]');
    let tabContainers = document.querySelectorAll('[data-mainNavContent]');
    let currentTab = '';
    let outsideClickListener = () => { };
    let logo = document.querySelector('[data-homepageLogo]');
    let mainContainer = document.querySelector('[data-mainNavContentWrapper]');
    let baseContent = document.querySelector('[data-baseContent]');
    let bgImg = document.querySelector('[data-bg]');

    function getBaseContentClass() {
        if (baseContent) {
            let baseContentClass = baseContent.getAttribute('data-baseContent');
            return baseContentClass;
        }
    }

    function closeTabs() {
        tabContainers.forEach(container => {
            container.classList.remove('_active');
        })

        tabBtns.forEach(btn => {
            btn.classList.remove('_current');
        })

        currentTab = '';
        removeClickListener();

        // mainContainer.classList.remove('_active', 'contactPage', '_catalogue', '_ticketPage', '_lkGrid');
        mainContainer.classList.remove('_active', getBaseContentClass());

        if (bgImg) {
            bgImg.classList.remove(getBaseContentClass());
        }

        if (!baseContent) {
            if (logo) {
                logo.classList.remove('_hidden');
            }
        }
    }

    function showBaseContent() {
        if (baseContent) {
            let baseContentClass = getBaseContentClass();
            let baseContentSection = document.querySelector(`[data-mainNavContent="${baseContentClass}"]`);
            baseContent.classList.add('_active', baseContentClass);
            baseContentSection.classList.add('_active');
            if (bgImg) {
                bgImg.classList.add(baseContentClass);
            }
        }
    }

    tabBtns.forEach(btn => {

        function openTab(evt) {
            evt.preventDefault();
            let targetName = btn.getAttribute('data-mainNavBtn');

            if (currentTab == targetName) {
                closeTabs();
                showBaseContent();
            } else {
                closeTabs();
                let targetContainer = document.querySelector(`[data-mainNavContent="${targetName}"]`);
                currentTab = targetName;
                targetContainer.classList.add('_active');
                btn.classList.add('_current');
                if (logo) {
                    logo.classList.add('_hidden');
                }
                mainContainer.classList.add('_active');



                outsideClickListener = (evt) => {
                    if (!mainContainer.contains(evt.target) && !mainMenu.contains(evt.target)) {
                        closeTabs();
                        showBaseContent();
                    }
                }
                document.addEventListener('click', outsideClickListener);
            }
        }

        btn.addEventListener('click', evt => openTab(evt));

    })

    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener);
    }


    // Open login panel if unauthorized
    const loginTabBtn = document.querySelector('[data-login_tab_btn]');
    if (loginTabBtn) {
        function openLoginTab() {
            closeTabs();
            let targetContainer = document.querySelector(`[data-mainNavContent="auth"]`);
            let tabsAuthBtn = document.querySelector('[data-mainnavbtn="auth"]');
            currentTab = "auth";
            targetContainer.classList.add('_active');
            tabsAuthBtn.classList.add('_current');
            if (logo) {
                logo.classList.add('_hidden');
            }
            mainContainer.classList.add('_active');
        }

        loginTabBtn.addEventListener('click', openLoginTab);
    }

}
